import { render, staticRenderFns } from "./TeamPageSkeleton.vue?vue&type=template&id=ce2e0506&scoped=true&"
var script = {}
import style0 from "./TeamPageSkeleton.vue?vue&type=style&index=0&id=ce2e0506&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce2e0506",
  null
  
)

export default component.exports